export const mandatoryPhone = {
  'Hello, friend!': 'Olá!',
  'We could not find your cellphone number through your social login':
    'Infelizmente não conseguimos encontrar seu número de celular através do seu login',
  'Please fill in the field below to continue browsing':
    'Por favor, informe no campo abaixo para continuar navegando',
  'Log out and identify yourself again': 'Sair e se identificar novamente',
  'Almost there!': 'Quase lá!',
  'We need your cellphone number to complete your sign-up':
    'Para concluir seu cadastro, precisamos que você informe seu celular',
  PHONE_PLACEHOLDER: '(XX) XXXXX-XXXX',
};
